import { render, staticRenderFns } from "./BaseModalSelect.vue?vue&type=template&id=000807f4&scoped=true"
import script from "./BaseModalSelect.vue?vue&type=script&lang=js"
export * from "./BaseModalSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseModalSelect.vue?vue&type=style&index=0&id=000807f4&prod&lang=scss&scoped=true"
import style1 from "./BaseModalSelect.vue?vue&type=style&index=1&id=000807f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000807f4",
  null
  
)

export default component.exports